import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import {
  SELECT_LABELS,
  getSelectOptionValue,
  selectPlaceholder,
  withSelectPlaceholder,
} from '../../services/selectOptions';

registerLocale('es', es);

const RESULTADO_OPTIONS = withSelectPlaceholder(
  [
    { value: 'R', label: 'Regular' },
    { value: 'L', label: 'Libre' },
  ],
  SELECT_LABELS.opcion
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatResultadoLabel(value) {
  if (value === 'R') return 'Regular';
  if (value === 'L') return 'Libre';
  return value || '—';
}

export class UpdateHistoriaAcademicaCursada extends Component {
  static displayName = UpdateHistoriaAcademicaCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '', carrera: '' },
      materia: { codigo: 0, anioAcademicoDescripcion: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      fecha: new Date(),
      fechaFinRegularidad: new Date(),
      observaciones: '',
      resultado: '',
      valueDictado: selectPlaceholder(SELECT_LABELS.opcion),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('HistoriaAcademicaCursada')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleDictadoChangeInput = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    const nextState = { valueDictado: option, resultado: value };
    if (value === 'L') {
      nextState.fechaFinRegularidad = null;
    }
    this.setState(nextState);
  };

  handleNameChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ observaciones: e.target.value });
  };

  handleFechaExamen = (date) => {
    this.clearFeedback();
    this.setState({ fecha: date });
  };

  handleStartDate = (date) => {
    this.clearFeedback();
    this.setState({ fechaFinRegularidad: date });
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;

    const resultadoValue = getSelectOptionValue(this.state.valueDictado, this.state.resultado);
    if (resultadoValue === 'R' && !this.state.fechaFinRegularidad) {
      this.setState({
        errorMessage: 'La fecha de fin de regularidad es obligatoria cuando el resultado es Regular.',
      });
      return;
    }

    this.saveStudent();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/hac/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la historia académica.'
        ),
      });
      return;
    }

    const model = data.returnModel;
    const resultado = model.historiaAcademicaResultado.trim();
    const selectedResultado = RESULTADO_OPTIONS.find((x) => x.value === resultado)
      || selectPlaceholder(SELECT_LABELS.opcion);
    const fechaFinRegularidad = resultado === 'L'
      ? null
      : constantClass.parseApiDate(model.historiaAcademicaFechaFinRegul);

    this.setState({
      loadingInitial: false,
      anio: {
        anioAcademicoCod: model.alumnoxCarreraCod,
        anioAcademicoDescripcion: model.alumnoxCarreraCodNavigation.alumnoNombre,
        carrera: model.alumnoxCarreraCodNavigation.carreraNombre,
      },
      materia: {
        codigo: model.materiaCarreraCod,
        anioAcademicoDescripcion: model.materiaCarreraCodNavigation.materiaCarreraNombre,
      },
      resultado,
      fecha: constantClass.parseApiDate(model.historiaAcademicaFecha),
      observaciones: model.historiaAcademicaCursadaObserv
        ? model.historiaAcademicaCursadaObserv.trim()
        : '',
      fechaFinRegularidad,
      valueDictado: selectedResultado,
    });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    const resultadoValue = getSelectOptionValue(this.state.valueDictado, this.state.resultado);

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/hac', {
      method: 'POST',
      body: JSON.stringify({
        HistoriaAcademicaCursadaCod: parseInt(this.state.id, 10),
        HistoriaAcademicaResultado: resultadoValue,
        HistoriaAcademicaFechaFinRegul: resultadoValue === 'L'
          ? null
          : constantClass.serializeDateForApi(this.state.fechaFinRegularidad),
        HistoriaAcademicaCursadaObserv: this.state.observaciones,
        HistoriaAcademicaFecha: constantClass.serializeDateForApi(this.state.fecha),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la historia académica. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-hic" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      anio,
      materia,
      fecha,
      fechaFinRegularidad,
      observaciones,
      resultado,
      valueDictado,
      errorMessage,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Historia Académica Cursada'
      : 'Modificar Historia Académica Cursada';
    const alumnoDisplay = anio.anioAcademicoDescripcion + ' - ' + anio.carrera;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-hic">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-hic">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-hic">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la historia académica de cursada.'
            : 'Actualice las fechas, el resultado u observaciones y guarde los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando historia académica, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <input
                className="md-form-page__input"
                type="text"
                value={alumnoDisplay}
                disabled
                readOnly
                aria-label="Alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              <input
                className="md-form-page__input"
                type="text"
                value={materia.anioAcademicoDescripcion}
                disabled
                readOnly
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Cursada</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(fecha)}
                    disabled
                    readOnly
                    aria-label="Fecha de cursada"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="hac-fecha-cursada">
                    Fecha de Cursada
                  </label>
                  <DatePicker
                    id="hac-fecha-cursada"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={fecha}
                    onChange={this.handleFechaExamen}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Resultado</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatResultadoLabel(resultado)}
                  disabled
                  readOnly
                  aria-label="Resultado"
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="hac-resultado"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueDictado}
                    options={RESULTADO_OPTIONS}
                    onChange={this.handleDictadoChangeInput}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Fin de Regularidad</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(fechaFinRegularidad)}
                    disabled
                    readOnly
                    aria-label="Fecha de fin de regularidad"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="hac-fecha-fin-regularidad">
                    Fecha de Fin de Regularidad
                    {resultado === 'R' ? ' (obligatorio)' : ''}
                  </label>
                  <DatePicker
                    id="hac-fecha-fin-regularidad"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={fechaFinRegularidad}
                    onChange={this.handleStartDate}
                    disabled={isBusy || resultado === 'L'}
                    dateFormat="dd/MM/yyyy"
                    placeholderText={resultado === 'L' ? 'No aplica para Libre' : 'Seleccione una fecha'}
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="hac-observaciones">
                Observaciones
              </label>
              <input
                id="hac-observaciones"
                className="md-form-page__input"
                type="text"
                value={observaciones}
                onChange={this.handleNameChangeInput}
                disabled={isBusy || this.isReadOnly}
                aria-label="Observaciones"
              />
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
